import { render } from "./dx-shukkinbo-confirm.vue?vue&type=template&id=4e36675c"
import script from "./dx-shukkinbo-confirm.vue?vue&type=script&lang=js"
export * from "./dx-shukkinbo-confirm.vue?vue&type=script&lang=js"

import "./dx-shukkinbo-confirm.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__